module.exports = __webpack_public_path__ + "img/bg-proyectos-9.9b686846.png";